import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {FormattedMessage, injectIntl} from 'react-intl';
import BaseButton from '../../../components/button/BaseButton';
import logo from '../../../assets/images/logo-studio.png';
import {go} from '../../../utils/navigationUtility';
import {isGuest} from '../../../utils/userUtility';

@injectIntl
@observer
class StudioHeader extends Component {
    onSignup = () => {
        go('/signup/select', {}, true);
    };

    onLogin = () => {
        go('/signin', {}, true);
    };

    renderHeaderActionButtons = () => {
        const {onExitCreateMode, onSave, isDisabledSave, intl: {formatMessage: translate}} = this.props;
        if (isGuest()) {
            return (
                <div className="m-studio-header">
                    <div className="m-studio-logo">
                        <img src={logo} alt="Musico Studio"/>
                    </div>
                    <div className="m-studio-buttons">
                        <a className="signin-btn" onClick={this.onLogin}>
                            <FormattedMessage id="studio.signin"/>
                        </a>
                        <BaseButton
                            className="signup-btn"
                            onClick={this.onSignup} disabled={false}
                            label={translate({id: 'studio.signup.mobile'})}/>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="m-studio-header">
                    <div className="m-studio-exit">
                        <button className="btn-exit" onClick={onExitCreateMode}>
                            <FormattedMessage id="studio.header.exit"/>
                        </button>
                    </div>
                    <div className="m-studio-logo">
                        <img src={logo} alt="Musico Studio"/>
                    </div>
                    <div className="m-studio-save">
                        <button className="btn-save" disabled={isDisabledSave} onClick={onSave}>
                            <FormattedMessage id="studio.header.save"/>
                        </button>
                    </div>
                </div>
            );
        }
    }

    render() {
        return this.renderHeaderActionButtons();
    }
}

export default StudioHeader;
